const NotEqualSignCircleIcon = /*#__PURE__*/ [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 9.77778H17M7 14.2222H17M8.66667 17L15.3333 7", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }]
];

export { NotEqualSignCircleIcon as default };
//# sourceMappingURL=NotEqualSignCircleIcon.js.map
